import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProjectCard = ({ project, onEdit, onDelete, onToggleFeatured, isSelected, onSelect }) => {
  const { id, title, image, imageAlt, floorType, room, tags = [], isFeatured } = project;

  return (
    <div className={`relative group bg-card border-2 rounded-lg overflow-hidden transition-all duration-200 ${isSelected ? 'border-primary' : 'border-border'} hover:shadow-lg`}>
      <div className="absolute top-3 left-3 z-10 flex gap-2">
        <button
          onClick={(e) => {
            e?.stopPropagation();
            onSelect(id);
          }}
          className={`w-6 h-6 rounded border-2 flex items-center justify-center transition-all duration-150 ${isSelected ? 'bg-primary border-primary' : 'bg-white border-border'}`}
          aria-label={`Select ${title}`}
        >
          {isSelected && <Icon name="Check" size={14} color="white" />}
        </button>
        {isFeatured && (
          <div className="bg-warning text-warning-foreground px-2 py-1 rounded text-xs font-medium flex items-center gap-1">
            <Icon name="Star" size={12} />
            Featured
          </div>
        )}
      </div>
      <div className="relative h-64 overflow-hidden">
        <Image
          src={image}
          alt={imageAlt}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
      </div>
      <div className="p-4 space-y-3">
        <div>
          <h3 className="text-lg font-semibold text-text-primary mb-1 line-clamp-1">{title}</h3>
          <div className="flex items-center gap-2 text-sm text-text-secondary">
            <Icon name="Grid3x3" size={14} />
            <span>{floorType}</span>
            <span className="text-border">•</span>
            <Icon name="Home" size={14} />
            <span>{room}</span>
          </div>
        </div>

        {tags?.length > 0 && (
          <div className="flex flex-wrap gap-1">
            {tags?.slice(0, 3)?.map((tag, index) => (
              <span key={index} className="px-2 py-1 bg-muted text-text-secondary text-xs rounded">
                {tag}
              </span>
            ))}
            {tags?.length > 3 && (
              <span className="px-2 py-1 bg-muted text-text-secondary text-xs rounded">
                +{tags?.length - 3}
              </span>
            )}
          </div>
        )}

        <div className="flex items-center gap-2 pt-2 border-t border-border">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onToggleFeatured(id)}
            iconName={isFeatured ? "StarOff" : "Star"}
            iconPosition="left"
            iconSize={14}
            className="flex-1"
          >
            {isFeatured ? 'Unfeature' : 'Feature'}
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onEdit(project)}
            iconName="Edit2"
            iconSize={14}
          />
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onDelete(id)}
            iconName="Trash2"
            iconSize={14}
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;